import accordion from "./accordion";

accordion();